import { IFeatureBase } from '../../models/features';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IFeatureListItem extends IFeatureBase {
  featureGroupsCount: number;
}

export type IFeatureList = IListResponse<IFeatureListItem>;

interface IListFeaturesProps {
  search?: string;
  limit?: number;
  page?: number;
}

export const listFeaturesService = async (
  filters: IListFeaturesProps,
): Promise<IFeatureList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          search: filters.search || undefined,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IFeatureList>('/features', {
    params,
  });

  return data;
};
